import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const PowerPointLogoInverse16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M658 987h-90V791h94q51 0 79 20t29 75q0 57-29 79t-83 22zM1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-117 0-229-26t-214-75-193-120-163-163h-97q-26 0-49-10t-41-27-28-41-10-50V512q0-26 10-49t27-41 41-28 50-10h97q73-91 163-162t192-121 215-75 229-26zm128 137v247q26 0 49 10t41 28 28 40 10 50v384h631q-21-147-87-276t-167-229-229-166-276-88zm-128-9q-177 0-338 66T398 384h626V128zM361 608v832h207v-272h106q65 0 121-19t99-57 66-90 24-122q0-70-22-121t-62-85-95-50-122-16H361zm663 1312q123 0 237-32t214-90 182-141 140-182 91-214 32-238h-640v513q0 26-10 49t-27 41-41 28-50 10H398q126 124 287 190t339 66z" />
    </svg>
  ),
  displayName: 'PowerPointLogoInverse16Icon',
});

export default PowerPointLogoInverse16Icon;
